/* tslint:disable */

declare var Object: any;
export interface SFBPJSKSReportInterface {
  "id"?: number;
}

export class SFBPJSKSReport implements SFBPJSKSReportInterface {
  "id": number;
  constructor(data?: SFBPJSKSReportInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFBPJSKSReport`.
   */
  public static getModelName() {
    return "SFBPJSKSReport";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFBPJSKSReport for dynamic purposes.
  **/
  public static factory(data: SFBPJSKSReportInterface): SFBPJSKSReport{
    return new SFBPJSKSReport(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFBPJSKSReport',
      plural: 'SFBPJSKSReports',
      path: 'SFBPJSKSReports',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFBPJSKSReport.ts